module.exports = __webpack_public_path__ + "img/card.6c62efbe.svg";